import { useMemo } from "react";
import { OrderItem } from "utils/types";

const OrderRow = (props: OrderItem & { timeZone: string }) => {
  const [date, time] = useMemo(() => {
    /*  if (!props.onDateTime) */ return [props.onDate, props.onTime];
    // return convertToTimezone(
    //   new Date(props.onDateTime),
    //   TIME_ZONES?.[props.timeZone] || "America/Los_Angeles"
    // ).split(", ");
  }, [props.onDate, props.onTime]);

  return (
    <div className="flex border-2 rounded-lg px-4 py-2">
      <p className="flex-1">{props.orderID}</p>
      <p className="flex-1">{props.orderType}</p>
      <p className="flex-1">{date}</p>
      <p className="flex-1">{time}</p>
      <p className="flex-1">{props.paymentType || "--"}</p>
      <p className="flex-1">{props.orderTotal.toFixed(2)}</p>
    </div>
  );
};

export default OrderRow;
